import packageJson from '../package.json';

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;
  isStaticExport: boolean;
};

export const CONFIG: ConfigValue = {
  appName: 'Testelope',
  appVersion: packageJson.version,
  serverUrl: process.env.NEXT_PUBLIC_TESTELOPE_API ?? '',
  assetsDir: process.env.NEXT_PUBLIC_ASSETS_DIR ?? '',
  isStaticExport: JSON.parse(`${process.env.BUILD_STATIC_EXPORT}`),
}
